import { render, staticRenderFns } from "./scholarInfo.vue?vue&type=template&id=790f1e18&scoped=true"
import script from "./scholarInfo.vue?vue&type=script&lang=js"
export * from "./scholarInfo.vue?vue&type=script&lang=js"
import style0 from "./scholarInfo.vue?vue&type=style&index=0&id=790f1e18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790f1e18",
  null
  
)

export default component.exports